module.exports = __webpack_public_path__ + "static/Modern Health-dbfb3ab75131c22a4c267d4795666935.jpg";